import { render, staticRenderFns } from "./PartSupplierDetailHistory.vue?vue&type=template&id=6df0fc2c"
import script from "./PartSupplierDetailHistory.vue?vue&type=script&lang=js"
export * from "./PartSupplierDetailHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports